import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-design-system';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { nothsTheme } from 'src/styles/noths.theme';

const { fonts, text, spacing } = theme;
const { color: nothsColor, font: nothsFont } = nothsTheme;

export const Container = css`
  &[data-no-padding='false'] {
    padding: ${pxToRem(spacing.md)};
  }
`;

export const StyledSubTitle = css`
  font-family: ${nothsFont.family.tertiary};
  ${fontSize(text.BODY.MD)};
  line-height: normal;
  font-weight: 400;
  font-style: italic;
  text-align: center;
  color: ${nothsColor.primary};
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 6px 0 50px 0;
`;

export const VideoBlockWrapper = css`
  width: 100%;
`;

export const VideoBlockRow = css`
  &[data-margin-top='true'] {
    margin-top: ${pxToRem(spacing.xl)};
    ${mediaQuery(
      { min: minBreakpoints.M },
      css`
        margin-top: ${pxToRem(spacing.xxl)};
      `,
    )};
  }
`;

export const CopyBlockWrapper = css`
  width: 100%;
  margin: 0 ${pxToRem(spacing.sm)};
`;

export const VideoBlockHeading = css`
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: normal;
  color: ${nothsColor.primaryDark};
  line-height: 1.333em;
  font-size: 22px;
  margin: 0 0 ${pxToRem(spacing.md)}; 0;
  text-transform: uppercase;
  text-align: center;
`;
